import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookieConsentService {
  private readonly COOKIE_CONSENT_KEY = 'cookie-consent';
  private readonly COOKIE_PREFERENCES_KEY = 'cookie-preferences';

  constructor() { }

  hasConsent(): boolean {
    const consent = localStorage.getItem(this.COOKIE_CONSENT_KEY);
    return consent === 'true';
  }

  setConsent(consent: boolean): void {
    localStorage.setItem(this.COOKIE_CONSENT_KEY, consent.toString());
  }

  getPreferences(): any {
    const preferences = localStorage.getItem(this.COOKIE_PREFERENCES_KEY);
    return preferences ? JSON.parse(preferences) : {
      necessary: true,
      analytics: false,
      marketing: false
    };
  }

  setPreferences(preferences: any): void {
    localStorage.setItem(this.COOKIE_PREFERENCES_KEY, JSON.stringify(preferences));
  }

  acceptAll(): void {
    this.setConsent(true);
    this.setPreferences({
      necessary: true,
      analytics: true,
      marketing: true
    });
  }

  acceptNecessaryOnly(): void {
    this.setConsent(true);
    this.setPreferences({
      necessary: true,
      analytics: false,
      marketing: false
    });
  }

  isAnalyticsEnabled(): boolean {
    const preferences = this.getPreferences();
    return preferences.analytics;
  }

  isMarketingEnabled(): boolean {
    const preferences = this.getPreferences();
    return preferences.marketing;
  }
}